/*
  Shoebox Drive Survey
  Copyright 2025 New Missions
*/

import * as React from 'react';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import EastRoundedIcon from '@mui/icons-material/EastRounded';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';

export interface PageProps {
  page: any;
  inputError: boolean;
  getInputValue: Function;
  handleInputChange: Function;
  submitPage: Function;
}

export default function Page ({
  page,
  inputError,
  getInputValue,
  handleInputChange,
  submitPage
}: PageProps) {
  return (
    <Stack spacing={2}>
      {page.questions.map((question: any, qIndex: number) => {
        const value = getInputValue(page.index, qIndex);
        const hasError = (inputError && question.required && !value?.trim());

        return (
          <TextField
            key={question.id}
            label={question.label}
            helperText={hasError
              ? 'This question is required.'
              : question.helperText || undefined
            }
            type={question.type || undefined}
            error={hasError || undefined}
            fullWidth
            variant="outlined"
            value={value}
            onChange={(e) => handleInputChange(page.index, qIndex, e.target.value)}
          />
        );
      })}
      <Button
        key={`submit-${page.index}`}
        fullWidth
        variant="contained"
        color="secondary"
        endIcon={page.submitLabel === 'Send' ? <CheckRoundedIcon /> : <EastRoundedIcon />}
        onClick={() => submitPage()}
      >
        {page.submitLabel || 'Next'}
      </Button>
    </Stack>
  );
}
